import { render, staticRenderFns } from "./cabinet-dashboard.vue?vue&type=template&id=014c55fc&scoped=true&"
import script from "./cabinet-dashboard.vue?vue&type=script&lang=js&"
export * from "./cabinet-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-dashboard.vue?vue&type=style&index=0&id=014c55fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c55fc",
  null
  
)

export default component.exports